import { Component, OnInit, Input, Injector } from '@angular/core';
import { IMatch, AthleteResultsStore } from '../../../../common-page-components/stores/entities-store/athlete-results-store';
import { TableAbstractComponent } from '../../../../common-page-components/classes/table-abstract-component';
import { ResultsAthleteFiltersService } from '../../services/results-athlete-filters.service';
import { HttpClient } from '@angular/common/http';
import { IHeaderConfig } from 'src/app/common-page-components/headers-component/headers-component.component';
import { IAthleteBiography } from 'src/app/common-page-components/stores/entities-store/athlete-biography-store';
import { PhaseStore } from 'src/app/common-page-components/stores/entities-store/phase-store';

@Component({
  selector: 'app-athlete-individual-results',
  templateUrl: './athlete-individual-results.component.html',
  styleUrls: ['./athlete-individual-results.component.scss']
})
export class AthleteIndividualResultsComponent extends TableAbstractComponent implements OnInit {
  /**
   * The headers of this table
   *
   * @type {Array<IHeaderConfig>}
   * @memberof BootstraAthleteMatchesComponent
   */
  headers: Array<IHeaderConfig> = [
    { name: "",},// Self match column
    { name: "" }, // Another match column
    { name: "" }, // Another match column
    { name:"" }, // Information about the phase.
    { name: "Matches"}, // Win Match column

  ];

  /**
   * Matches of the athlete for individual component
   *
   * @type {Array<IMatch>}
   * @memberof AthleteIndividualResultsComponent
   */
  @Input() matches: Array<IMatch>;

  constructor(injector:Injector, public results_service:ResultsAthleteFiltersService, http:HttpClient) {
    super(injector,results_service, new PhaseStore(http));
    this.model.requestData({'RBP':'ALL'}, false).subscribe();
  }

  /**
   *
   * @inheritdoc
   * @memberof AthleteIndividualResultsComponent
   */
  ngOnInit() {
  }

  /**
   * A getter for get the athlete from common service
   *
   * @returns {IAthleteBiography}
   * @memberof AthleteIndividualResultsComponent
   */
  get getSelfAthlete():IAthleteBiography{
    return this.results_service.common_service.athleteDetailStore.data[0];
  }

}
